module.exports = __webpack_public_path__ + "img/38987-110.bc2e5e75.jpg";